import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import { CustomFormLabel, RHFDatePicker } from '@/components/form-controls';

export const RegistrationFields = () => {
  const { t } = useTranslation('nomenclature-page');

  return (
    <Grid container xs={12} columnSpacing={2}>
      <Grid xs={4}>
        <FormControl fullWidth>
          <CustomFormLabel htmlFor="startRegDate">{t('modals.form.ui.registration.start-date')}</CustomFormLabel>
          <RHFDatePicker
            name="startRegDate"
            format="dd.MM.yyyy"
            TextFieldProps={{
              fullWidth: true,
              id: 'startRegDate',
              variant: 'filled',
            }}
          />
        </FormControl>
      </Grid>

      <Grid xs={4}>
        <FormControl fullWidth>
          <CustomFormLabel htmlFor="endRegDate">{t('modals.form.ui.registration.end-date')}</CustomFormLabel>
          <RHFDatePicker
            name="endRegDate"
            format="dd.MM.yyyy"
            TextFieldProps={{
              fullWidth: true,
              id: 'endRegDate',
              variant: 'filled',
            }}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};
